import { useEffect, useState, useCallback } from "react";
import { findCountryByCode, guessCountry } from "../config/countries";

const STORAGE_KEY = "ool_country_v1";

const readStored = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.code) return null;
        const full = findCountryByCode(parsed.code);
        return full || null;
    } catch {
        return null;
    }
};

export const useCountry = () => {
    const [country, setCountryState] = useState(() => readStored());
    const [ready, setReady] = useState(false);

    useEffect(() => {
        // First-load resolution
        const stored = readStored();
        if (stored) {
            setCountryState(stored);
        }
        setReady(true);

        const onStorage = (e) => {
            if (e.key === STORAGE_KEY) setCountryState(readStored());
        };
        window.addEventListener("storage", onStorage);
        return () => window.removeEventListener("storage", onStorage);
    }, []);

    const setCountry = useCallback((c) => {
        if (!c) {
            localStorage.removeItem(STORAGE_KEY);
            setCountryState(null);
            return;
        }
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ code: c.code }));
        setCountryState(c);
    }, []);

    const clear = useCallback(() => {
        localStorage.removeItem(STORAGE_KEY);
        setCountryState(null);
    }, []);

    return { country, setCountry, clear, ready, guess: guessCountry };
};
